/** Money + date + number formatters. Centralised so we never get inconsistent ₹ formatting. */

const INR = new Intl.NumberFormat('en-IN', {
  style: 'currency',
  currency: 'INR',
  maximumFractionDigits: 0,
});

const INRCompact = new Intl.NumberFormat('en-IN', {
  style: 'currency',
  currency: 'INR',
  notation: 'compact',
  maximumFractionDigits: 1,
});

/** Money is stored as paisa (int64) on the backend. Pass paisa, get ₹X,XXX. */
export function formatMoney(paisa: number): string {
  return INR.format(Math.round(paisa / 100));
}

export function formatMoneyCompact(paisa: number): string {
  return INRCompact.format(Math.round(paisa / 100));
}

/** Pass a rupee amount directly. Use when you already have rupees, not paisa. */
export function formatRupees(rupees: number): string {
  return INR.format(rupees);
}

export function formatNumber(n: number): string {
  return new Intl.NumberFormat('en-IN').format(n);
}

export function formatCompactNumber(n: number): string {
  return new Intl.NumberFormat('en-IN', { notation: 'compact', maximumFractionDigits: 1 }).format(
    n,
  );
}
